import script from "./users.vue?vue&type=script&setup=true&lang=js"
export * from "./users.vue?vue&type=script&setup=true&lang=js"

import "./users.vue?vue&type=style&index=0&id=93b1c9ac&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93b1c9ac"]])

export default __exports__